/**
 * BookingFlows internal funnel analytics for the React booking widget
 * (/book?org=slug direct URLs). Anonymous, batched, fail-open — must never
 * affect the booking flow. Mirrors the tracker inside services-grid.html.
 */
import { API_URL } from '../config/api';

let vid;
try {
  const urlVid = new URLSearchParams(window.location.search).get('bf_vid');
  if (urlVid && urlVid.length < 64) {
    vid = urlVid;
    try { localStorage.setItem('bf_vid', vid); } catch (e) { /* private mode */ }
  } else {
    vid = localStorage.getItem('bf_vid');
    if (!vid) {
      vid = 'v_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      localStorage.setItem('bf_vid', vid);
    }
  }
} catch (e) { vid = 'v_' + Math.random().toString(36).slice(2, 12); }

let sid;
try {
  sid = sessionStorage.getItem('bf_sid');
  if (!sid) {
    sid = 's_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    sessionStorage.setItem('bf_sid', sid);
  }
} catch (e) { sid = 's_' + Math.random().toString(36).slice(2, 10); }

let queue = [];
let flushTimer = null;
let queuedOrg = null;

function device() {
  try { const w = window.innerWidth; return w < 768 ? 'mobile' : w < 1100 ? 'tablet' : 'desktop'; }
  catch (e) { return 'desktop'; }
}

function flush() {
  flushTimer = null;
  if (!queue.length || !queuedOrg) return;
  try {
    const payload = JSON.stringify({ orgId: queuedOrg, events: queue.splice(0, 25) });
    const url = `${API_URL}/v2/public/analytics/track`;
    let sent = false;
    // text/plain avoids a CORS preflight — the backend parses the raw body
    if (navigator.sendBeacon) {
      try { sent = navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' })); } catch (e) { /* fall through */ }
    }
    if (!sent) {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch (e) { /* analytics must never break the widget */ }
}

let utm = null;
try {
  const q = new URLSearchParams(window.location.search);
  if (q.get('utm_campaign') || q.get('utm_source')) {
    utm = { source: q.get('utm_source') || null, medium: q.get('utm_medium') || null, campaign: q.get('utm_campaign') || null };
  }
} catch (e) { /* fail open */ }

export function bfTrack(orgId, type, meta = null) {
  try {
    if (!orgId || !type) return;
    queuedOrg = orgId;
    if (utm) meta = { ...(meta || {}), utm };
    queue.push({
      type,
      serviceId: (meta && meta.serviceId) || null,
      sessionId: sid,
      visitorId: vid,
      meta,
      pageUrl: (window.location.origin + window.location.pathname).slice(0, 500),
      referrer: (document.referrer || '').slice(0, 500),
      device: device(),
    });
    if (!flushTimer) flushTimer = setTimeout(flush, 1500);
  } catch (e) { /* fail open */ }
}

try { window.addEventListener('pagehide', flush); } catch (e) { /* SSR safety */ }
